import cx from 'classnames'
import type React from 'react'

import type { Props } from '../../types'
import css from './SwitchNormal.module.scss'

const SwitchNormal: React.FC<Props> = ({
  leftCorner,
  rightCorner,
  classes,
  checked,
  onChange,
  width = 32,
}) => {
  const styles = {
    container: cx(css.container, classes?.container),
    bar: cx(css.bar, classes?.bar),
    leftControl: cx(css.control, classes?.control, {
      [css.active]: !checked,
    }),
    rightControl: cx(css.control, classes?.control, {
      [css.active]: checked,
    }),
  }

  return (
    <div className={styles.container}>
      <div className={styles.bar} onClick={() => onChange?.(!checked)}>
        <div className={styles.leftControl} style={{ width: `${width}px` }}>
          {leftCorner}
        </div>
        <div className={styles.rightControl} style={{ width: `${width}px` }}>
          {rightCorner}
        </div>
      </div>
    </div>
  )
}

export default SwitchNormal
